import { ChangeDetectorRef, Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { loggedInUserViewModel } from 'src/app/all-modules/admin/models/user-management/user_models';
import { UserManagementService } from 'src/app/all-modules/admin/services/user-management/user-management.service';
import { AuthService } from 'src/app/all-modules/core/service/auth.service';
import { ApiResponse } from 'src/app/all-modules/shared/common-model/common.model';
import { MESSAGE_CATEGORY_CONSTATNS, ROLE_CONSTANTS } from 'src/app/all-modules/shared/constants/constant';
import { CommonToastService } from 'src/app/all-modules/shared/services/common-toast.service';
import { CommonService } from 'src/app/all-modules/shared/services/common.service';
import { SpinnerService } from 'src/app/all-modules/shared/services/spinner.service';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrl: './user-profile.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserProfileComponent {
  userId!: string;
  userDetails!: loggedInUserViewModel;
  profileImage = '';
  isProfilePicDialog = false;
  changeProfilePicFile!: any;
  changeProfileFormGroup!: FormGroup;
  profilePicImageDisplay: any;
  isopenChangePasswordScreen = false;

  constructor(private router: Router,
    private userService: UserManagementService, private spinerService: SpinnerService, private commonToastService: CommonToastService,
    private commonService: CommonService, private spinnerService: SpinnerService, private authService: AuthService,
    private _formBuilder: FormBuilder, private cdr: ChangeDetectorRef,) {


    this.commonService.loggedInUserDetails$.subscribe((user: loggedInUserViewModel) => {
      if (!!user) {
        this.userDetails = user;
        if (this.userDetails.profilePicBase64 != null) {
          this.profileImage = 'data:image/png;base64,' + this.userDetails.profilePicBase64;
        }
        else {
          this.profileImage = "assets/images/empty-profile.png";
        }
      }
    });


  }
  getDialCode(dialCode: string) {
    if (dialCode === "+1_") {
      return "+1";
    }
    return dialCode;
  }
  ngOnInit() {
    this.initForm();
    this.changeProfileFormGroup.controls['profilePic']?.valueChanges.subscribe(value => {
      this.onFileChange(value);
    });
  }

  initForm() {
    this.changeProfileFormGroup = this._formBuilder.group({
      profilePic: [''],
      password: [null, [Validators.required, Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$')]],
      confirmPassword: [null, Validators.required],
    }, { validator: this.passwordMatchValidator });
  }

  back() {
    this.router.navigate(["/admin/users"]);
  }

  openProfilePicDialog() {
    this.isProfilePicDialog = true;
  }

  closeProfilePicDialog() {
    this.isProfilePicDialog = false;
    this.removeFile();
  }

  changeProfilePic() {
    if (this.changeProfilePicFile == null || this.changeProfilePicFile == '' || this.changeProfilePicFile == undefined) {
      this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.WARNING, MESSAGE_CATEGORY_CONSTATNS.USER_PROFILE, 'Please select profile picture');
      return;
    }
    this.spinerService.show();
    this.isProfilePicDialog = false
    const formData = new FormData();
    formData.append("ProfilePic", this.changeProfilePicFile);
    this.userService.ChangeProfilePic(formData).subscribe(
      (response) => {
        this.spinerService.hide();
        if (response.success) {
          this.commonService.GetLoggedInUserDetails();
          this.removeFile();
        }
        this.commonToastService.showToasterMessage(response.msgCategoryKey, response.msgCategoryTitle, response.message);
        this.spinerService.hide();
      }, (error) => {
        this.spinerService.hide();
        this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.USER_PROFILE, error);
        console.error('Error saving data:', error);
      });
  }

  removeFile(): void {
    this.changeProfilePicFile = null;
    this.profilePicImageDisplay = '';
    this.changeProfileFormGroup.controls['profilePic'].setValue(null);
  }

  onFileChange(files: any) {
    if (files) {
      const file = files;
      this.changeProfilePicFile = files;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.profilePicImageDisplay = reader.result;
        this.cdr.detectChanges();
      };
    }
  }

  passwordMatchValidator(form: FormGroup) {
    const password = form?.get('password')?.value;
    const confirmPassword = form?.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { mismatch: true };
  }

  openChangePasswordScreen() {
    this.isopenChangePasswordScreen = !this.isopenChangePasswordScreen;
    this.initForm();
  }

  changePassword(formData: any) {
    if (this.changeProfileFormGroup.invalid) {
      return;
    }
    this.spinnerService.show();
    const payload = {
      "Password": formData.confirmPassword
    }
    this.userService.ResetPassword(payload).subscribe(
      (res: any) => {
        if (res.success) {
          this.authService.logout();
          this.spinnerService.hide();
        }
        this.commonToastService.showToasterMessage(res.msgCategoryKey, res.msgCategoryTitle, res.message);
        this.spinnerService.hide();
      },
      (error) => {
        this.spinnerService.hide();
        this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.USER_PROFILE, error);
      });
  }

  cancelPassword() {
    this.isopenChangePasswordScreen = false;
    this.changeProfileFormGroup.controls['password'].setValue(null);
    this.changeProfileFormGroup.controls['confirmPassword'].setValue(null);
    this.changeProfileFormGroup.get('password')?.clearValidators();
    this.changeProfileFormGroup.get('confirmPassword')?.clearValidators();
  }
  estimationUpdateForMigration() {
    if (localStorage.getItem('roleKey') === ROLE_CONSTANTS.ADMIN) {
      this.userService.estimationUpdateForMigration().subscribe({
        next: (res: ApiResponse) => {
         
        },
        error: (error) => {
          this.spinnerService.hide();
        }
      });
    }
  }
  estimationUpdateForMigrationRateCard() {
    if (localStorage.getItem('roleKey') === ROLE_CONSTANTS.ADMIN) {
      this.userService.estimationUpdateForMigrationUpateRateCard().subscribe({
        next: (res: ApiResponse) => {
          if (res.success) {
           this.estimationUpdateForMigration();
          }
        },
        error: (error) => {
          this.spinnerService.hide();
        }
      });
    }
  }
}
